import ActionMetaBuilder from 'storeState/ActionMetaBuilder';

export const PREFIX = "TENANTS";

export const actionMeta = new ActionMetaBuilder(PREFIX);

actionMeta.defineRequest({
  name: "tenants_list",
  urlBuilder: () => 'tenants/'
});

actionMeta.defineRequest({
    name: "tenant_delete",
    urlBuilder: ({tenant_id}) => 'tenants/'+tenant_id
});

actionMeta.defineRequest({
    name: "tenant_create",
    urlBuilder: () => 'tenants/'
});

actionMeta.defineRequest({
    name: "tenant_update",
    urlBuilder: ({tenant_id}) => 'tenants/'+tenant_id
});



// WEBPACK FOOTER //
// ./src/storeState/tenants/meta.js